export default "__VITE_ASSET__S5Hum2Hn__"